import styled from 'styled-components';

export const ExchangeContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 120px);
    font-weight: bolder;
`